import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './style';

export interface Props {
    backGroundImg: string;
    backGroundColor?: string;
    width?: number;
    height?: number;
    radius?: number;
    href?: string;
    onClick?: () => void;
}

function BtnImg({ href, ...props }: Props): React.ReactElement {
    const history = useHistory();

    const onClickHrefCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (href) history.push(href);
        },
        [history, href]
    );

    if (href) {
        return <S.ButtonImg onClick={onClickHrefCallback} isOnClick={true} {...props}></S.ButtonImg>;
    } else {
        return <S.ButtonImg isOnClick={false} {...props}></S.ButtonImg>;
    }
}
export default BtnImg;
